"use client";
import { parseCookies } from "nookies";

export async function FetchSingleEvent(eventId) {
  const serverURL = process.env.NEXT_PUBLIC_REACT_APP_SERVER;
  let url = `${serverURL}/events/${eventId}`;
  const cookies = parseCookies();
  const token = cookies.token;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch events");
  }

  return res.json();
}
